import React, { Component, Fragment, useRef } from 'react';
import '../global';
import { connect } from 'react-redux';
import { documentTypeFilter } from '../actions';

class BookStoreSideBar extends Component {
	constructor(props) {
		super(props);
		this.state = {
		  expandedSections: {}, 
		  isMobile: false, 
		  showSideBar: false,

		};
	
		// Bind methods to this
		this.toggleSection = this.toggleSection.bind(this);
		this.renderCategories = this.renderCategories.bind(this);
		this.getSearch = this.getSearch.bind(this);
		this.handleMobileSidebarToggle = this.handleMobileSidebarToggle.bind(this);
		this.renderDocumentTypes = this.renderDocumentTypes.bind(this);
		this.book_document_types = getBookStoreObj().book_document_types;
	  }
	

	handleResize() {
		//IF UPDATING SIZE HERE, UPDATE IN _CATEGORY-ARCHIVE.SCSS AS WELL.
		const isMobile = window.innerWidth <= 992;

		if ( !isMobile && this.state.showFilters ) {
			this.setState( { showFilters: false } );
			document.body.classList.remove( 'no-scroll' );
		} else {
			this.setState( { isMobile } );
		}
	}

	handleDocumentTypeClick(document_type_slug) {
		this.props.documentTypeFilter(document_type_slug);
	}

	componentDidMount() {
		this.handleResize();
		window.addEventListener('resize', this.handleResize.bind(this));
	  
		// Add event listeners to the mobile sidebar toggle buttons
		const mobileSidebarButtons = document.querySelectorAll('#mobile-sidebar-options, .btn-show-categories');
		mobileSidebarButtons.forEach(button => {
		  button.addEventListener('click', this.handleMobileSidebarToggle);
		});
		//For scroll 
		this.handleScroll = this.handleScroll.bind(this);
		window.addEventListener('scroll', this.handleScroll);
		this.sidebarRef = React.createRef();
		this.handleScroll();
	  }

	  componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize.bind(this));
	  
		// Remove event listeners from the mobile sidebar toggle buttons
		const mobileSidebarButtons = document.querySelectorAll('#mobile-sidebar-options, .btn-show-categories');
		mobileSidebarButtons.forEach(button => {
		  button.removeEventListener('click', this.handleMobileSidebarToggle);
		});
		window.removeEventListener('scroll', this.handleScroll);

	  }

	  handleMobileSidebarToggle() {
		this.setState(prevState => ({
		  showSideBar: !prevState.showSideBar
		}), () => {
		  if (this.state.showSideBar && this.sidebarRef.current) {
			this.sidebarRef.current.style.bottom = 'auto';
			this.sidebarRef.current.style.top = '0';
		  }
		});
	  }

	  handleScroll() {
		const sidebar = this.sidebarRef.current;
		const footer = document.querySelector('.site-footer');
		const loginBlock = document.querySelector('.login-block-common');
		if (!sidebar || !footer) return;
	
		const sidebarRect = sidebar.getBoundingClientRect();
		const footerRect = footer.getBoundingClientRect();
		const windowHeight = window.innerHeight;
		if (loginBlock && window.getComputedStyle(loginBlock).display === 'block') {
		  sidebar.style.bottom = 'auto';
		} else if (footerRect.top <= windowHeight) {
		  const overlap = windowHeight - footerRect.top;
		  sidebar.style.bottom = `${overlap}px`;
		  sidebar.style.top = 'auto';
		  sidebar.style.height = '120vh';
		  sidebar.style.overflowY = 'hidden';
		} else {
		  sidebar.style.position = 'fixed';
		  sidebar.style.top = 'initial';
		  sidebar.style.bottom = 'auto';
		  sidebar.style.height = '100%';
		  sidebar.style.overflowY = 'auto';
		}
		if (this.state.showSideBar) {
		  sidebar.style.bottom = 'auto';
		  sidebar.style.top = 0;
		}
	  }

	toggleSection(index) {
		this.setState(function(prevState) {
			return {
				expandedSections: {
					...prevState.expandedSections,
					[index]: !prevState.expandedSections[index]
				}
			};
		});
	}

	renderCategories(categories, parentIndex = '', subCategories = false, parentSlug = '') {
		return categories.map((category, index) => {
			const fullIndex = parentIndex ? `${parentIndex}-${index}` : `${index}`;
			const isExpanded = this.state.expandedSections[fullIndex];
			const hasSubCategories = category.sub_categories.length > 0;
			const jumpSlug = subCategories ? `${parentSlug}-${category.slug}` : category.slug;
	
			return (
				<div key={fullIndex} className={`sidebar-item-main-container ${subCategories ? 'sub-category' : ''}`}>
					<div className="">
						{hasSubCategories ? (
							<div className="sidebar-item-header">
							<a href={`#jump-${jumpSlug}`} 
								// className="sidebar-item-header-link"

							>
								<b>{category.name}</b>
								</a>
									<i 
										className={`fa-solid fa-chevron-${isExpanded ? 'up' : 'right'}`}
										onClick={this.toggleSection.bind(this, fullIndex)}
									></i>								
							</div>
						) : (
							<a 
								href={`#jump-${jumpSlug}`}
								className="sidebar-item-header"
								onClick={this.state.isMobile ? this.handleMobileSidebarToggle : null}
							>
								<b>{category.name}</b>
								<i 
									className="fa-solid fa-arrow-right arrow-icon"
								></i>
							</a>
						)}
					</div>
					{ isExpanded && hasSubCategories && (
						<div className="sidebar-item-subcategories">
							{this.renderCategories(category.sub_categories, fullIndex, true, category.slug)}
						</div>
					)}
				</div>
			);
		});
	}

	getSearch() {
		return (<div>
				<div className={ 'sidebar-heading-container' }>
					<h3 className="sidebar-heading">Find on Page</h3>
				</div>
				<form class="form-inline" id="bookstore-find-on-page">
					<div class="side-bar-form-group">
						<input id="find-on-page" type="text" class="sidebar-input"/>
						<span id="bookstore-find-on-page-results"></span>
						<button role="submit" id="btn-find-catalog-text" className="sidebar-button">Search</button>
						{/* <span class="help-block">
							After starting a search, hit "Enter" to jump to the next search-term match.<br/>
							As an alternative, use the Ctrl + F keys to view all matches on this page.
						</span> */}
					</div>
				</form>
				{/* <input
					type="text"
					id="search"
					name="search"
					className="search-input"
					placeholder="Filter by keyword"
					value={ this.state.searchTerm }
					onChange={ this.handleSearchChange }
				/> */}
			</div>
		);
	}

	renderDocumentTypes() {
		return (
			<div>
				<div className={'sidebar-heading-container'}>
					<h3 className="sidebar-heading">Document Types</h3>
				</div>
				{this.book_document_types.map((document_type, index) => (
					<div className="filter-checkbox-container" key={index} onClick={() => this.handleDocumentTypeClick(document_type.slug)}>
						<label className="custom-checkbox no-parent" htmlFor={`checkbox-${index}`}>
							<input 
								type="checkbox" 
								id={`checkbox-${index}`} 
								className="" 
								name="select-subcategory" 
								checked={Array.isArray(this.props.document_type_filter) && this.props.document_type_filter.includes(document_type.slug)}
							/>
							<span className="checkmark"></span>
						</label>
						<label htmlFor={`checkbox-${index}`}>{document_type.name}</label>
					</div>
				))}
			</div>
		);
	}
	render() {
		const bookSections = getBookStoreObj().book_sections;

		return (
			<div className={`col-lg-3 side-bar side-bar-container ${this.state.showSideBar ? 'active' : ''}`} ref={this.sidebarRef}>
				<div className="side-bar-desktop">

					{ !this.state.isMobile ? this.getSearch() : null}
					{ !this.state.isMobile ? <hr className={'section-divider'}/> : null}

					<div className="sidebar-heading-container">
						<h2 className="sidebar-heading">Sections</h2>
					</div>
					<p className="sidebar-description">
						Please select the section you want to explore.
					</p>
					{this.renderCategories(bookSections)}
					{/* {this.renderDocumentTypes()} */}
					
				</div>
				{this.state.showSideBar && (
					<button className="done-button" onClick={this.handleMobileSidebarToggle}>Done</button>
				)}
			</div>
		);
	}

}

function mapStateToProps( { document_type_filter } ) {
	return {
		document_type_filter
	};
};

export default  connect(mapStateToProps, { documentTypeFilter })(BookStoreSideBar);
